import FingerprintJS from "@fingerprintjs/fingerprintjs";

/**
 * ✅ Fetch guest data from MySQL via backend API
 */
export async function checkGuestInMySQL() {
    const guestId = await getGuestId();
    try {
        //const response = await fetch(`http://localhost:5000/api/guests/${guestId}`);
        const response = await fetch(`/api/guests/${guestId}`);
        const data = await response.json();

        if (response.ok) {
            console.log("✅ Guest found in MySQL:", data);
            return data; // Returns guest data with credits
        } else {
            console.warn("❌ Guest not found:", data.error);
            return null;
        }
    } catch (error) {
        console.error("Error fetching guest data from MySQL:", error);
        return null;
    }
}

/**
 * ✅ Fetch user data from MySQL via backend API
 */
export async function checkUserInMySQL(userId) {

    try {
        const response = await fetch(`/api/profile/${userId}`);
        const data = await response.json();

        if (response.ok) {
            console.log("✅ User found in MySQL:", data);
            return data; // Returns guest data with credits
        } else {
            console.warn("❌ User not found:", data.error);
            return null;
        }
    } catch (error) {
        console.error("Error fetching user data from MySQL:", error);
        return null;
    }
}



/**
 * Get or generate a persistent guest ID
 */
export async function getGuestId() {
    let guestId = localStorage.getItem("guestId");

    if (!guestId) {
        console.log("Generating new guest ID...");
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        guestId = result.visitorId;
        localStorage.setItem("guestId", guestId);
    }

    return guestId;
}

/**
 * Track Guest Credits in MySQL
 */
export async function trackGuestCredits() {
    const guestId = await getGuestId();
    try {
        //const response = await fetch("http://localhost:5000/api/guests", {
        const response = await fetch("/api/guests", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ guestId }),
        });

        const data = await response.json();
        console.log("✅ Guest Data:", data);
        return data.credits;
    } catch (error) {
        console.error("Error tracking guest credits:", error);
    }
}

/**
 * Use a Credit in MySQL
 */
export async function useCredit() {
    const guestId = await getGuestId();
    try {
        //const response = await fetch(`http://localhost:5000/api/guests/use-credit/${guestId}`, {
        const response = await fetch(`/api/guests/use-credit/${guestId}`, {
            method: "PUT",
        });

        const data = await response.json();
        console.log("✅ Credits Updated:", data);
        return data.success;
    } catch (error) {
        console.error("Error using guest credit:", error);
    }
}
